const axios = require('axios');
const baseUrl = process.env.REACT_APP_API_URL;

export const getFAQPage = (id:string) => axios.get(`${baseUrl}/webflow/faq/${id}`);
export const voteOnFAQ = (id:string | undefined, vote:number, type:string) => axios.post(`${baseUrl}/webflow/faq/${id}/vote`, { vote, type });